import React from "react";
import JagmohanImage from "../../images/about/Jagmohan.webp";

const JagmohanSinghSection = () => {
  return (
    <section className="jagmohan-singh-section section-padding">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          {/* Left Side - Circular Image */}
          <div className="col-xl-5 col-lg-5 col-md-6 col-12" style={{}}>
            <div className="jagmohan-image-wrapper text-center">
              <div className="circular-image">
                <img
                  src={JagmohanImage}
                  alt="CA Jagmohan Singh - India's No.1 Cash Flow Expert"
                />
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="col-xl-7 col-lg-7 col-md-6 col-12">
            <div className="jagmohan-content">
              <p className="jagmohan-description" style={{ textAlign: "justify" }}>
                Jagmohan Singh is India's No.1 Cash Flow Expert, Chartered
                Accountant (All India Rank), author, and founder of JSA Online.
                He is the creator of the Cash Flow Revolution, a worldwide
                movement aimed at helping business owners build not just
                profitable, but truly cash-rich businesses. Through his powerful
                frameworks such as the Financial Health Checkup Report (FHCR),
                Cash Flow Helpline (CFH), FC21 and Retainership services, he has
                transformed the financial direction of thousands of MSMEs and
                entrepreneurs.
              </p>
              <p className="jagmohan-description" style={{ textAlign: "justify" }}>
                Jagmohan Singh is the host of the prestigious Cash Flow Summit
                2026 (Stadium Event, New Delhi), the architect of the Cash Flow
                Revolution World Tour, and author of the bestselling books{" "}
                <strong>Financial Freedom with Financial Control</strong> and{" "}
                <strong>Cash Flow Mastery</strong>. He has been awarded globally
                in London, Dubai, and India, and is a keynote speaker for top
                business associations across the country. Guided by Sikh values
                of Sewa, Bhakti and Truth, his mission is to create a
                financially strong and cash-confident India.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JagmohanSinghSection;
